import {Fancybox} from "@fancyapps/ui";

const initLightBox = () => {
    Fancybox.bind("[data-fancybox]", {
        Thumbs: false,
        Slideshow: false
    });
}

export {initLightBox}
